
import { Injectable } from '@angular/core';


@Injectable()
export class TokenGuard  {

  constructor() {
  }

  //we will null out the username if the token is not good
  canActivate() {

    var storedToken = sessionStorage.getItem("token");
    if (storedToken == "") {
      return false;
    }
    return true;
  }

}
